<lib-panel-layout>
  <div class="flex flex-col w-full min-w-0 items-stretch gap-3 lg:flex-row lg:flex-wrap lg:items-center lg:justify-center">
    <div class="flex w-full flex-wrap items-center justify-center gap-2">
      <lib-number-input
        class="w-full"
        [label]="'EDITOR.CONTROLS.WIDTH' | translate"
        [value]="viewModel?.width"
        [min]="1"
        [max]="50000"
        (changed)="onWidthPixelsChanged($event)"
        unit="px">
      </lib-number-input>
      <lib-number-input
        class="w-full"
        [label]="'EDITOR.CONTROLS.HEIGHT' | translate"
        [value]="viewModel?.height"
        [min]="1"
        [max]="50000"
        (changed)="onHeightPixelsChanged($event)"
        unit="px">
      </lib-number-input>
      <lib-number-input
        class="w-full"
        [label]="'EDITOR.CONTROLS.X_SCALE' | translate"
        [value]="viewModel?.scaleXPercentage"
        [min]="1"
        [max]="5000"
        (changed)="onWidthPercentageChanged($event)"
        unit="%">
      </lib-number-input>
      <lib-number-input
        class="w-full"
        [label]="'EDITOR.CONTROLS.Y_SCALE' | translate"
        [value]="viewModel?.scaleYPercentage ?? 1"
        [min]="1"
        [max]="5000"
        (changed)="onHeightPercentageChanged($event)"
        unit="%">
      </lib-number-input>

      <lib-checkbox
        class="w-full self-end"
        [label]="'EDITOR.CONTROLS.LOCK_ASPECT_RATIO' | translate"
        [checked]="viewModel?.keepAspectRatio ?? false"
        (changed)="onKeepAspectChanged($event)">
      </lib-checkbox>
    </div>
  </div>

  <lib-apply-panel panelActions class="w-full" (apply)="onApply()" (cancelRequested)="onCancel()"> </lib-apply-panel>
</lib-panel-layout>
